import React, { memo, useEffect } from "react";
import { Link,useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import $ from "jquery";
import { ConditionalBlock } from "../../ConditionalBlock";
import { useSelector, useDispatch } from "react-redux";
import { ProjectMenuIcon, ProjectRequestsMenuIcon, ReportsMenuIcon, WorkspaceMenuIcon } from "../../AppIcons";
import { updateCampaignDeliveryStatus } from "../../redux/reducers/CampaignDeliveryStatusFilterSlice";
const LeftNavbar = memo((props) => {
  const { t } = useTranslation();
  const translate = t;
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const expandFunction = () => {
    var element = document.getElementById("container");
    element.classList.toggle("expand-left");
    document.getElementById("container").classList.remove("expand-right");
    document.getElementById("left-list").classList.remove("expand-left");
    $('.left-burgur-menu').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
    $('.left-burgur-menu').attr('aria-selected', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
  };
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const accountPermission = useSelector((updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data).value;
  const getPermissions = useSelector((rolePermissionSelected) => rolePermissionSelected.role_permission).value;
  const closeLeftNavBar = (e) => {
    if ((e.keyCode === 9 && e.shiftKey === false) || e.keyCode === 40) {
      document
        .getElementById("openHeader-Menu")
        .classList.remove("expand-header");
        document.getElementById("left-list").classList.remove("expand-left");
        if ($(window).width() < 768) {
        setTimeout(() => {
          $(".hamburger-menu").trigger("focus");
        });
        $('.hamburger-menu').attr('aria-expanded', function(index, attr){
          return attr === 'true' ? 'false': 'true';
        });
      }
    }
  };
  const dispatch = useDispatch();

  const leftNavContent = (event) => {
    if($(".visibleHidden").hasClass("expand-left")){
        if ($(window).width() < 768) {
        if (document.activeElement.id === 'asideList') {
        if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            document
          .getElementById("openHeader-Menu")
          .classList.remove("expand-header");
          document.getElementById("left-list").classList.remove("expand-left");
            $(".hamburger-menu").trigger("focus");
            $('.hamburger-menu').attr('aria-expanded', function(index, attr){
              return attr === 'true' ? 'false': 'true';
            });
          }
         }
         
         if (event.key === Constants.ESCAPE) {
          $(".hamburger-menu").trigger("focus");
          $("#left-list").removeClass("expand-left");
          $("#openHeader-Menu").removeClass("expand-header");
          $('.hamburger-menu').attr('aria-expanded', function(index, attr){
            return attr === 'true' ? 'false': 'true';
          });
        }
       
      }
   }
  }
  return (
    <aside id="left-list" className="left-sidebar visibleHidden" onKeyDown={(e) => leftNavContent(e)}>
      <ul role="tablist" data-tour="left-navigation">
        <li role="none"></li>
        <li role="none">
          <button
            className="left-burgur-menu"
            onClick={expandFunction}
            aria-selected='false'
            aria-label="Expand list"
            aria-live="polite"
            role="tab"
            aria-expanded="false"
            data-tour="expand-navigation"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="12"
              viewBox="0 0 17 12"
              fill="none"
            >
              <rect width="17" height="2" rx="1" fill="#3F77E0" />
              <rect y="5" width="12" height="2" rx="1" fill="#3F77E0" />
              <rect y="10" width="15" height="2" rx="1" fill="#3F77E0" />
            </svg>
          </button>
        </li>
        {getPermissions?.includes('FINANCE_PROJECTS_MENU') ? 
            <li role="none">
            <Link id="asideList" to="/finance/projects" state={{ retainFilter: true }}
              aria-label={splitLocation[1] === "projects" ? "Current tab projects" : "projects"}
              role="tab"
              aria-selected={splitLocation[1] === "projects" ? "true" : "false"}
              className={splitLocation[1] === "projects" ? "active" : ""}>
              <span className="project-icon flex-center"> 
              {ProjectMenuIcon}
              </span>
              <strong>{translate("left_navbar.projects")}</strong>
            </Link>
          </li>
        : <li role="none">
          <Link id="asideList" to="/projects"
            aria-label={splitLocation[1] === "projects" ? "Current tab projects" : "projects"}
            role="tab"
            aria-selected={splitLocation[1] === "projects" ? "true" : "false"}
            className={splitLocation[1] === "projects" ? "active" : ""}>
            <span className="project-icon flex-center">
              {ProjectMenuIcon}
            </span>
            <strong>{translate("left_navbar.projects")}</strong>
          </Link>
        </li>}
        <ConditionalBlock condition={custBootstrapDataRedux?.features?.PROJECT_REQUESTER}>
          {getPermissions?.includes('PROJECT_REQUEST_LIST')? (
            <li role="none">
              <Link to="/project-request/list"
              aria-label={splitLocation[1] === "project-request" ? "Current tab Projects Request" : "Projects Request"}
              role="tab"
              aria-selected={splitLocation[1] === "project-request" ? "true" : "false"}
              className={splitLocation[1] === "project-request" ? "active" : ""}
              >
                <span className="project-icon flex-center">
                  {ProjectRequestsMenuIcon}
                </span>
                <strong>{translate("left_navbar.projects_request")}</strong>
              </Link>
            </li>
          ) : null }
        </ConditionalBlock>
        <ConditionalBlock condition={custBootstrapDataRedux?.features?.PROJECT_WORKSPACES}>
          {getPermissions?.includes('CAMPAIGNS_MENU')? (
            <li onClick={()=>
                dispatch(updateCampaignDeliveryStatus(""))
            } role="none">
              <Link to="/campaigns?status=OPEN"
              aria-label={splitLocation[1] === "campaigns" ? "Current tab Campaigns" : "Campaigns"}
              role="tab"
              aria-selected={splitLocation[1] === "campaigns" ? "true" : "false"}
              className={splitLocation[1] === "campaigns" ? "active" : ""}>
                <span 
                onClick={()=>
                  dispatch(updateCampaignDeliveryStatus(""))
                 }
                className="campaigns-icon flex-center">
                  {WorkspaceMenuIcon}
                </span>
                <strong>{translate("left_navbar.campaigns")}</strong>
              </Link>
            </li>
            ) : null }
        </ConditionalBlock>
         {getPermissions?.includes('TASKS_MENU')? (
        <li role="none">
          <Link to="/task/all"
           aria-label={splitLocation[1] === "task" ? "Current tab tasks" : "tasks"}
           role="tab"
           aria-selected={splitLocation[1] === "task" ? "true" : "false"}
            className={splitLocation[1] === "task" ? "active" : ""}>
            <span className="reports-icon flex-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                shapeRendering="geometricPrecision"
                textRendering="geometricPrecision"
                imageRendering="optimizeQuality"
                fillRule="evenodd"
                clipRule="evenodd"
                viewBox="0 0 419 511.67"
                fill="#1D4ED8"
                height="24"
                className="aaa-white"
              >
                <path d="M93 39.4h46.13C141.84 17.18 159.77 0 181.52 0c21.61 0 39.45 16.95 42.33 38.94l46.77.46c2.61 0 4.7 2.1 4.7 4.71v51.84a4.69 4.69 0 0 1-4.7 4.71H93.05c-2.56 0-4.71-2.1-4.71-4.71V44.11A4.644 4.644 0 0 1 93 39.4zm221.97 264.22c57.47 0 104.03 46.58 104.03 104.02 0 57.47-46.59 104.03-104.03 104.03-57.47 0-104.02-46.58-104.02-104.03 0-57.47 46.58-104.02 104.02-104.02zm16.14 53.2c6.21 6.21 3.92 15.81-2.55 21.1-6.24 5.03-17.54 7.47-23.99 1.54-6.5-6.06-3.92-15.79 2.31-21.12 6.01-5.06 17.89-7.84 24.23-1.52zM294.4 438.4h5.3v-34.56h-10.05c0-13.7 25.14-4.81 43.65-9.47v44.03h7v14.71h-45.9V438.4zM41.73 59.28h23.93v24.37H41.73c-4.77 0-9.12 1.97-12.25 5.1-3.14 3.14-5.1 7.48-5.1 12.24v315.53c0 4.74 1.96 9.09 5.1 12.23 3.15 3.15 7.51 5.12 12.25 5.12h142.61c1.69 8.44 4.17 16.6 7.37 24.38H41.73c-11.45 0-21.9-4.71-29.47-12.28C4.72 438.43 0 427.98 0 416.52V100.99c0-11.48 4.7-21.91 12.25-29.46 7.55-7.55 17.99-12.25 29.48-12.25zm297.54 217.35V100.99c0-4.77-1.96-9.11-5.09-12.26a17.377 17.377 0 0 0-12.26-5.08H298V59.28h23.92c11.45 0 21.86 4.71 29.41 12.25 7.61 7.61 12.32 18.04 12.32 29.46V283.6c-7.79-3.07-15.95-5.42-24.38-6.97zm-206.74-8.06c-7.13 0-12.92-5.79-12.92-12.92s5.79-12.93 12.92-12.93h142.82c7.13 0 12.92 5.8 12.92 12.93s-5.79 12.92-12.92 12.92H132.53zM89.5 241.21c7.97 0 14.44 6.47 14.44 14.45 0 7.98-6.47 14.43-14.44 14.43s-14.44-6.45-14.44-14.43c0-7.98 6.47-14.45 14.44-14.45zm0 78.62c7.97 0 14.44 6.47 14.44 14.45 0 7.97-6.47 14.43-14.44 14.43s-14.44-6.46-14.44-14.43c0-7.98 6.47-14.45 14.44-14.45zm43.04 27.37c-7.13 0-12.93-5.8-12.93-12.93s5.8-12.93 12.93-12.93h80.96a133.376 133.376 0 0 0-17.26 25.86h-63.7zM89.5 162.61c7.97 0 14.44 6.46 14.44 14.43 0 7.98-6.47 14.44-14.44 14.44s-14.44-6.46-14.44-14.44c0-7.97 6.47-14.43 14.44-14.43zm43.03 27.35c-7.13 0-12.92-5.79-12.92-12.92s5.79-12.93 12.92-12.93h142.82c7.13 0 12.92 5.8 12.92 12.93s-5.79 12.92-12.92 12.92H132.53zm48.5-169.8c12.3 0 22.26 9.96 22.26 22.27 0 12.29-9.96 22.26-22.26 22.26s-22.26-9.97-22.26-22.26c0-12.31 9.96-22.27 22.26-22.27z" />
              </svg>
            </span>
            <strong>{translate("left_navbar.tasks")}</strong>
          </Link>
        </li>
         ) :null }
         {getPermissions?.includes('REPORTS_MENU')? (
        <li role="none">
          <Link to="/reports"
            aria-label={splitLocation[1] === "reports" ? "Current tab reports" : "reports"}
            role="tab"
            aria-selected={splitLocation[1] === "reports" ? "true" : "false"}
            className={splitLocation[1] === "reports" ? "active" : ""}>
            
            <span className="reports-icon flex-center">
              {ReportsMenuIcon}
            </span>
            <strong>{translate("left_navbar.reports")}</strong>
          </Link>
        </li>
         ) :null}

      {getPermissions?.includes('FINANCE_REPORTS_MENU')? (
        <li role="none">
          <Link to="/finance/reports" state={{ retainFilter: true }}
            aria-label={splitLocation[1] === "reports" ? "Current tab reports" : "reports"}
            role="tab"
            aria-selected={splitLocation[1] === "reports" ? "true" : "false"}
            className={splitLocation[1] === "reports" ? "active" : ""}>
            
            <span className="reports-icon flex-center">
              {ReportsMenuIcon}
            </span>
            <strong>{translate("left_navbar.reports")}</strong>
          </Link>
        </li>
         ) :null}

         {getPermissions?.includes('VENDORS_MENU')? (
        <li role="none">
          <Link to="/vendor/customer-vendor/"
             aria-label={splitLocation[1] === "vendor" ? "Current tab vendor" : "vendor"}
             role="tab"
             aria-selected={splitLocation[1] === "vendor" ? "true" : "false"}
             className={splitLocation[1] === "vendor" ? "active" : ""}>
            <span className="vendors-icon flex-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="19"
                viewBox="0 0 22 19"
                fill="none"
              >
                <path
                  d="M15.5403 18V16.1911C15.5403 15.2316 15.1576 14.3114 14.4765 13.6329C13.7953 12.9545 12.8714 12.5733 11.908 12.5733H4.64342C3.68007 12.5733 2.75618 12.9545 2.07499 13.6329C1.3938 14.3114 1.01111 15.2316 1.01111 16.1911V18"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.27574 8.95555C10.2818 8.95555 11.908 7.33582 11.908 5.33778C11.908 3.33973 10.2818 1.72 8.27574 1.72C6.26967 1.72 4.64343 3.33973 4.64343 5.33778C4.64343 7.33582 6.26967 8.95555 8.27574 8.95555Z"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20.9888 18V16.1911C20.9882 15.3895 20.7203 14.6108 20.2272 13.9773C19.7341 13.3438 19.0438 12.8913 18.2645 12.6909"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.6322 1.83757C15.4135 2.03682 16.106 2.48941 16.6006 3.12397C17.0951 3.75854 17.3636 4.53899 17.3636 5.34229C17.3636 6.1456 17.0951 6.92605 16.6006 7.56062C16.106 8.19518 15.4135 8.64777 14.6322 8.84702"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <strong>{translate("left_navbar.vendors")}</strong>
          </Link>
        </li>
        ) :null }
         {getPermissions?.includes('ONE_TM_MENU') && accountPermission?.permissions?.TM_READ_EDIT? (
        <li role="none">
          <Link to={"/one-tm"}
             aria-label={splitLocation[1] === "one-tm" ? "Current tab one tm" : "one tm"}
             role="tab"
             aria-selected={splitLocation[1] === "one-tm" ? "true" : "false"}
             className={splitLocation[1] === "one-tm" ? "active" : ""}>
            <span
              onClick={() => localStorage.removeItem("url")}
              className="onetm-icon flex-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1 12V9.75C1 9.15326 1.23705 8.58097 1.65901 8.15901C2.08097 7.73705 2.65326 7.5 3.25 7.5H16.75C17.3467 7.5 17.919 7.73705 18.341 8.15901C18.7629 8.58097 19 9.15326 19 9.75V12C19 12.5967 18.7629 13.169 18.341 13.591C17.919 14.0129 17.3467 14.25 16.75 14.25H3.25C2.65326 14.25 2.08097 14.0129 1.65901 13.591C1.23705 13.169 1 12.5967 1 12Z"
                  stroke="#1D4ED8"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.5 10.875C5.5 10.5766 5.38147 10.2905 5.17049 10.0795C4.95952 9.86853 4.67337 9.75 4.375 9.75C4.07663 9.75 3.79048 9.86853 3.57951 10.0795C3.36853 10.2905 3.25 10.5766 3.25 10.875C3.25 11.1734 3.36853 11.4595 3.57951 11.6705C3.79048 11.8815 4.07663 12 4.375 12C4.67337 12 4.95952 11.8815 5.17049 11.6705C5.38147 11.4595 5.5 11.1734 5.5 10.875Z"
                  fill="#1D4ED8"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1 5.24325L1.01125 2.99325C1.01304 2.39768 1.25088 1.82712 1.67264 1.40662C2.0944 0.986123 2.66568 0.749997 3.26125 0.75H16.75C17.3175 0.750104 17.8639 0.964618 18.2799 1.35057C18.6959 1.73652 18.9507 2.26539 18.9932 2.83125L19 3.00675L18.9887 5.25675C18.987 5.85232 18.7491 6.42288 18.3274 6.84338C17.9056 7.26388 17.3343 7.5 16.7387 7.5H3.25C2.68235 7.50018 2.13561 7.28579 1.71938 6.89982C1.30315 6.51384 1.0482 5.9848 1.00563 5.41875L1 5.24325Z"
                  stroke="#1D4ED8"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.5 4.125C5.5 3.82663 5.38147 3.54048 5.17049 3.32951C4.95952 3.11853 4.67337 3 4.375 3C4.07663 3 3.79048 3.11853 3.57951 3.32951C3.36853 3.54048 3.25 3.82663 3.25 4.125C3.25 4.42337 3.36853 4.70952 3.57951 4.92049C3.79048 5.13147 4.07663 5.25 4.375 5.25C4.67337 5.25 4.95952 5.13147 5.17049 4.92049C5.38147 4.70952 5.5 4.42337 5.5 4.125Z"
                  fill="#1D4ED8"
                />
              </svg>
            </span>
            <strong>{translate("left_navbar.one_tm")}</strong>
          </Link>
        </li>
        ) :null }
        {getPermissions?.includes('REFERENCE_MENU') && accountPermission?.permissions?.GLOSSARY_READ ? (
        <li role="none" onKeyDown={(e) => closeLeftNavBar(e)}>
          <Link to="/reference"
           aria-label={splitLocation[1] === "reference" ? "Current tab reference" : "reference"}
           role="tab"
           aria-selected={splitLocation[1] === "reference" ? "true" : "false"}
             id="lastLeftLink" className={splitLocation[1] === "reference" ? "active" : ""}>
            <span className="reference-icon flex-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="20"
                viewBox="0 0 16 20"
                fill="none"
              >
                <path
                  d="M1 2.9998C1 1.8955 1.89512 1 3.00025 1H11.0004C12.1046 1 12.9998 1.8955 12.9998 2.9998V4.9996M1 2.9998V17.0002C1 18.1045 1.89512 19 3.00025 19H12.9998C14.1049 19 15 18.1045 15 17.0002V6.7996C15 6.32221 14.8156 5.86437 14.4874 5.52681C14.1592 5.18924 13.7141 4.9996 13.25 4.9996H3.00025C1.89512 4.9996 1 4.105 1 2.9998Z"
                  stroke="#1D4ED8"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 5C1 4.46957 1.19754 3.96086 1.54917 3.58579C1.90081 3.21071 2.37772 3 2.875 3H13"
                  stroke="#1D4ED8"
                  strokeWidth="0.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <strong>{translate("left_navbar.reference")}</strong>
          </Link>
        </li>
         ) :null }

        {getPermissions?.includes('LEFT_MENU_DISCUSSION')? (
          <li role="none" onKeyDown={(e) => closeLeftNavBar(e)}>
            <Link to="/discussions"
              aria-label={splitLocation[1] === "discussions" ? "Current tab discussions" : "discussions"}
              role="tab"
              aria-selected={splitLocation[1] === "discussions" ? "true" : "false"}
               className={splitLocation[1] === "discussions" ? "active" : ""}>
              <span className="reference-icon flex-center">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="20" 
                height="20" 
                viewBox="0 0 20 20" 
                fill="none">
                  <path 
                  d="M2.5 1.25C2.16848 1.25 1.85054 1.3817 1.61612 1.61612C1.3817 1.85054 1.25 2.16848 1.25 2.5V12.5C1.25 12.8315 1.3817 13.1495 1.61612 13.3839C1.85054 13.6183 2.16848 13.75 2.5 13.75H14.4825C15.1455 13.7501 15.7813 14.0136 16.25 14.4825L18.75 16.9825V2.5C18.75 2.16848 18.6183 1.85054 18.3839 1.61612C18.1495 1.3817 17.8315 1.25 17.5 1.25H2.5ZM17.5 0C18.163 0 18.7989 0.263392 19.2678 0.732233C19.7366 1.20107 20 1.83696 20 2.5V18.4913C20 18.6149 19.9633 18.7358 19.8945 18.8386C19.8257 18.9414 19.728 19.0215 19.6138 19.0687C19.4995 19.116 19.3737 19.1282 19.2525 19.104C19.1312 19.0797 19.0198 19.0201 18.9325 18.9325L15.3663 15.3663C15.1319 15.1318 14.814 15.0001 14.4825 15H2.5C1.83696 15 1.20107 14.7366 0.732233 14.2678C0.263392 13.7989 0 13.163 0 12.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L17.5 0Z" 
                  fill="#1D4ED8"
                  />
                  <path 
                  d="M3.75 4.375C3.75 4.20924 3.81585 4.05027 3.93306 3.93306C4.05027 3.81585 4.20924 3.75 4.375 3.75H15.625C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375C16.25 4.54076 16.1842 4.69973 16.0669 4.81694C15.9497 4.93415 15.7908 5 15.625 5H4.375C4.20924 5 4.05027 4.93415 3.93306 4.81694C3.81585 4.69973 3.75 4.54076 3.75 4.375ZM3.75 7.5C3.75 7.33424 3.81585 7.17527 3.93306 7.05806C4.05027 6.94085 4.20924 6.875 4.375 6.875H15.625C15.7908 6.875 15.9497 6.94085 16.0669 7.05806C16.1842 7.17527 16.25 7.33424 16.25 7.5C16.25 7.66576 16.1842 7.82473 16.0669 7.94194C15.9497 8.05915 15.7908 8.125 15.625 8.125H4.375C4.20924 8.125 4.05027 8.05915 3.93306 7.94194C3.81585 7.82473 3.75 7.66576 3.75 7.5ZM3.75 10.625C3.75 10.4592 3.81585 10.3003 3.93306 10.1831C4.05027 10.0658 4.20924 10 4.375 10H10.625C10.7908 10 10.9497 10.0658 11.0669 10.1831C11.1842 10.3003 11.25 10.4592 11.25 10.625C11.25 10.7908 11.1842 10.9497 11.0669 11.0669C10.9497 11.1842 10.7908 11.25 10.625 11.25H4.375C4.20924 11.25 4.05027 11.1842 3.93306 11.0669C3.81585 10.9497 3.75 10.7908 3.75 10.625Z" 
                  fill="#1D4ED8"
                  />
                </svg>
              </span>
              <strong>{translate("left_navbar.discussions")}</strong>
            </Link>
          </li>
        ) : null}
      </ul>
    </aside>
  );
});

LeftNavbar.propTypes = {};

export default LeftNavbar;
